export default __webpack_public_path__ + "static/media/usericon.ae3a914b.png";